<template>
  <v-container align-start pb-0>
    <v-row no-gutters>
      <v-col cols="12" align="center" v-if="!hasStripe &&!isHefe && !status.loading.userJobs&& !firstEntry" class="mb-2 px-1">
        <v-btn color="info" large block tile to="/stripe-registration">
          <v-icon>info_outline</v-icon><span class="heading white--text px-2">Signup with Stripe Required</span>
          <v-progress-circular indeterminate v-if="(userProfile.balances || false).waitingForUrl || false" class="pl-2" color="white"></v-progress-circular>
        </v-btn>
      </v-col>
      <v-col cols="12" justify="center" v-if="hasStripe&&!payoutsEnabled &&!isHefe && !status.loading.userJobs&& !firstEntry" class="info mb-2">
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" md="10">
            <v-list-item dense to="/stripe-registration" color="error">
              <v-list-item-avatar tile class="px-0">
                <v-icon color="white">info_outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters>
                  <span :class="`${$vuetify.breakpoint.mdAndUp?'body-1':'caption'} white--text`" v-if="hasStripe&&!payoutsEnabled">{{$language.jobDetails['Pending Stripe']}}</span>
                  <v-progress-circular indeterminate v-if="(userProfile.balances || false).waitingForUrl || false" class="pl-2" color="white"></v-progress-circular>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="8" v-if="$vuetify.breakpoint.smAndUp" :class="$vuetify.breakpoint.lgAndUp?'px-1':''">
        <v-card :height="$vuetify.breakpoint.smAndDown?$vuetify.breakpoint.height-195:$vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-175:$vuetify.breakpoint.height-175">
          <v-toolbar flat v-if="!showLFFMap">
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
              {{$language.dashboard.Calendar['Today']}}
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>
                    {{$language.dashboard.Calendar['Day']}}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>
                    {{$language.dashboard.Calendar['Week']}}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>
                    {{$language.dashboard.Calendar['Month']}}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>
                    {{$language.dashboard.Calendar['4 Day']}}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-sheet :height="$vuetify.breakpoint.height -170" v-if="!showLFFMap">
            <v-calendar ref="calendar" v-model="focus" color="primary" :events="schedule" :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange"></v-calendar>
            <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" max-width="450">
              <job-list-item :key="(selectedEvent.jobData||{})._key" :is-invite="(selectedEvent.jobData|{}).status==='Invited'||false" :from-dashboard="true" :from-search="false" :job-data="selectedEvent.jobData||{}"></job-list-item>
            </v-menu>
          </v-sheet>

          <gmap-map v-if="showLFFMap" id="map" ref="map" :options="mapOptions" :center="{lat: (((userProfile || {}).location || {}).coords || {})[0] || 0,lng: (((userProfile || {}).location || {}).coords || {})[1] || 0,
                  }" :zoom="11" :style="`height: ${
                    $vuetify.breakpoint.xs ? 199 : $vuetify.breakpoint.sm ? 350 : $vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-120:400
                  }px`">
            <gmap-marker v-for="(job,index) in startedJobs" :position="getCoordinates(job)" :icon="processIcon(job)" :clickable="true" :key="index" @click="openInfoWindowTemplate(job)" />

            <gmap-info-window :options="{maxWidth: 450,minWidth:320}" :position="infoWindow.position" :opened="infoWindow.open" @closeclick="infoWindow.open=false">
              <job-list-item :key="(infoWindow.job||{})._key" :is-invite="(infoWindow.job|{}).status==='Invited'||false" :from-dashboard="true" :from-search="false" :job-data="infoWindow.job||{}"></job-list-item>
            </gmap-info-window>
            <gmap-marker :position="{
                      lat: (((userProfile || {}).location || {}).coords || {})[0] || 0,
                      lng: (((userProfile || {}).location || {}).coords || {})[1] || 0,
                    }" />

          </gmap-map>
        </v-card>

      </v-col>
      <v-col cols="12" sm="6" md="6" lg="4" :class="$vuetify.breakpoint.smAndUp?'px-1':''">
        <v-card class="px-1 pt-2" flat tile>

          <v-row no-gutters v-if="!status.loading.userJobs">
            <v-row no-gutters align="end">
              <v-col cols="12" align="end" justify="end">

                <template v-if="$vuetify.breakpoint.mdAndUp">

                  <v-btn small icon @click="showLFFMap=true" class="mr-1" v-if="!showLFFMap">
                    <v-icon>map</v-icon>
                  </v-btn>
                  <v-btn small icon @click="showLFFMap=false" class="mx-2" v-else>
                    <v-icon>today</v-icon>
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn small icon @click="mapDialog=true" class="mx-2">
                    <v-icon>map</v-icon>
                  </v-btn>
                  <v-btn small icon @click="scheduleDialog=true" class="mx-2">
                    <v-icon>today</v-icon>
                  </v-btn>
                </template>
                <v-btn small icon @click="changeView(false)" v-if="listView" class="mx-2">
                  <v-icon large>view_stream</v-icon>
                </v-btn>
                <v-btn small icon @click="changeView(true)" v-if="!listView" class="mx-2">
                  <v-icon large>list</v-icon>
                </v-btn>
                <v-btn small icon @click="handlePanel" class="mx-2">
                  <v-icon size="22">fa-filter</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" class="pa-0">

                <v-expansion-panels v-model="filterPanel">
                  <v-expansion-panel expand v-model="filterPanel">
                    <v-expansion-panel-content>
                      <v-item-group v-model="obrFilters" multiple class="pt-4 " v-if="(userProfile.userType||{}).obr">
                        <v-item v-slot:default="{ active, toggle }" value="Started" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Started']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Applied" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Applied']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Hired" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Hired']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Invited" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Invited']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Completed" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Completed']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Pending Payment" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Pending Payment']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Paid" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Paid']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Canceled" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Cancelled']}}</v-chip>
                        </v-item>
                      </v-item-group>
                      <v-item-group v-model="hefeFilters" multiple class="pt-4 " v-if="(userProfile.userType||{}).hefe">
                        <v-item v-slot:default="{ active, toggle }" value="Draft" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Draft']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Scheduled" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Scheduled']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Published-Public" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Published-Public']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Published-Private" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Published-Private']}}</v-chip>
                        </v-item>
                        <v-item v-slot:default="{ active, toggle }" value="Pending Payment" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Pending Payment']}}</v-chip>
                        </v-item>

                        <v-item v-slot:default="{ active, toggle }" value="Completed" class="ma-1">
                          <v-chip rounded class="mr-1 px-4" @click="toggle" :color="active?'primary':''">{{$language.jobDetails.status['Completed']}}</v-chip>
                        </v-item>
                      </v-item-group>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col cols="12">
                <v-divider class="my-1"></v-divider>

              </v-col>

            </v-row>
            <v-col cols="12">
              <v-row justify="center" align="center" v-if="filteredJobs.length === 0" class="pt-6">
                <v-card flat tile :height="$vuetify.breakpoint.smAndDown?$vuetify.breakpoint.height-195:$vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-175:$vuetify.breakpoint.height-175">
                  <span v-if="filteredJobs.length === 0">{{ $language.jobSearch['There are no jobs to show at the moment.'] }}</span>

                </v-card>
              </v-row>
              <v-virtual-scroll v-else bench="10" :items="filteredJobs" :height="$vuetify.breakpoint.smAndDown?$vuetify.breakpoint.height-180:$vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-150:$vuetify.breakpoint.height-150" item-height="220">
                <template v-slot="{ item }">

                  <job-list-item :key="item._key" :is-invite="item.status==='Invited'||false" :from-dashboard="true" :from-search="false" :job-data="item"></job-list-item>
                </template>
              </v-virtual-scroll>
            </v-col>

          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <h4 class="white--text mt-3">{{ $language.dashboard['Loading Dashboard information'] }}</h4>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-dialog v-model="mapDialog" fullscreen persistent :overlay="false" transition="dialog-transition">
        <v-card flat tile>

          <v-btn icon color="primary" style="position:fixed;left:16px;top:16px; z-index:10000" @click="mapDialog=false">
            <v-icon large>mdi-close-circle-outline</v-icon>
          </v-btn>
          <gmap-map id="map" ref="map" :options="mapOptions" :center="{
                    lat: (((userProfile || {}).location || {}).coords || {})[0] || 0,
                    lng: (((userProfile || {}).location || {}).coords || {})[1] || 0,
                  }" :zoom="11" :style="`height: ${
                    $vuetify.breakpoint.height
                  }px`">
            <gmap-marker v-for="(job,index5) in startedJobs" :position="getCoordinates(job)" :icon="processIcon(job)" :clickable="true" :key="index5" @click="openInfoWindowTemplate(job)" />

            <gmap-info-window :options="{maxWidth: 450,minWidth:320}" :position="infoWindow.position" :opened="infoWindow.open" @closeclick="infoWindow.open=false">
              <job-list-item :key="(infoWindow.job||{})._key" :is-invite="(infoWindow.job|{}).status==='Invited'||false" :from-dashboard="true" :from-search="false" :job-data="infoWindow.job||{}"></job-list-item>
            </gmap-info-window>
            <gmap-marker :position="{
                      lat: (((userProfile || {}).location || {}).coords || {})[0] || 0,
                      lng: (((userProfile || {}).location || {}).coords || {})[1] || 0,
                    }" />
          </gmap-map>
        </v-card>
      </v-dialog>
      <v-dialog v-model="scheduleDialog" scrollable fullscreen persistent :overlay="false" transition="dialog-transition">
        <v-card flat tile>

          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn icon color="primary" @click="scheduleDialog=false">
                <v-icon large>mdi-close-circle-outline</v-icon>
              </v-btn>
              <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                {{$language.dashboard.Calendar['Today']}}
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>
                      {{$language.dashboard.Calendar['Day']}}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>
                      {{$language.dashboard.Calendar['Week']}}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>
                      {{$language.dashboard.Calendar['Month']}}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>
                      {{$language.dashboard.Calendar['4 Day']}}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet :height="$vuetify.breakpoint.height-56" v-if="!showLFFMap">
            <v-calendar ref="calendar" v-model="focus" color="primary" :events="schedule" :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange"></v-calendar>
            <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
              <job-list-item :key="(selectedEvent.jobData||{})._key" :is-invite="(selectedEvent.jobData|{}).status==='Invited'||false" :from-dashboard="true" :from-search="false" :job-data="selectedEvent.jobData||{}"></job-list-item>
            </v-menu>
          </v-sheet>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>

import { gmapApi } from 'vue2-google-maps'
import {
  mapState
} from 'vuex'
import moment from 'moment'
// import HefeJobListItem from '@/components/jefe/HefeJobListItem'
import JobListItem from '@/components/common/JobListItem'
// import InviteListItem from '@/components/obrero/InviteListItem'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    // HefeJobListItem,
    JobListItem
    // InviteListItem
  },
  data () {
    return {
      snackbar: {
        show: false,
        message: ''
      },
      jobToEdit: null,
      jobToInvite: null,
      showFilter: false,
      filter: this.$language.dashboard.hefeFilters[0], // Doing this because the "No filter" is in the same position for both obrero and worker
      dialogs: {
        'job-details': false,
        'job-add': false,
        'job-edit': false,
        'favorites-invite': false
      },
      mapDialog: false,
      scheduleDialog: false,
      thisJob: {
        showWarning: false,
        showMessagesWarning: false
      },
      defaultJob: {
        showWarning: false,
        showMessagesWarning: false
      },
      defaultTab: 'Summary',
      referralId: null,
      backToTransactions: false,
      filterPanel: [],
      listView: false,
      showLFFMap: false,
      focus: '',
      type: 'day',
      typeToLabel: {
        month: this.$language.dashboard.Calendar['Month'],
        week: this.$language.dashboard.Calendar['Week'],
        day: this.$language.dashboard.Calendar['Day'],
        '4day': this.$language.dashboard.Calendar['4 Days']
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      obrFilters: ['Started', 'Applied', 'Hired', 'Invited', 'Completed', 'Pending Payment', 'Cancelled'],
      hefeFilters: ['Draft', 'Scheduled', 'Published-Public', 'Published-Private', 'Pending Payment', 'Completed', 'Cancelled'],
      index: 0,
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: ''
      }
    }
  },
  mounted: function () {
    this.index += this.index
    if (this.$route.query.jobId) {
      fb.database.ref(`/user/${this.currentUser.uid}/jobs/${this.$route.query.jobId}/createdBy`).once('value').then((snap) => {
        var createdBy = snap.val()
        if (createdBy === this.currentUser.uid) {
          this.$router.push(`/hefe/job-details/${this.$route.query.jobId}?tab=Summary`)
        } else {
          this.$router.push(`/obrero/job-details/${this.$route.query.jobId}?tab=Summary`)
        }
      })
    }
    if (this.$route.query.referralId) {
      this.referralId = this.$route.query.referralId
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/referralId`] = this.referralId
      fb.database.ref().update(updates)
    }
    // this.filters = ((this.userJobs || {}).userType || {}).hefe ? ['Draft', 'Published-Public', 'Published-Private', 'Paid'] : ['Hired', 'Started', 'Scheduled', 'Completed', 'Applied', 'Invited']
  },
  computed: {
    google: gmapApi,
    ...mapState(['userProfile', 'currentUser', 'userJobs', 'jobLoading', 'status', 'addDialog', 'openJob']),
    hasSources () {
      return (((this.userProfile || {}).stripeCustomerAccount || {}).sources || {}).data !== undefined
    },

    isHefe () {
      return ((this.userProfile || {}).userType || {}).hefe
    },
    isObr () {
      return ((this.userProfile || {}).userType || {}).obr
    },
    hasStripe () {
      var pending = (((this.userProfile || {}).stripeAccount || {}).account || false)
      return pending
    },
    payoutsEnabled () {
      var pending = ((((this.userProfile || {}).stripeAccount || {}).account || {}).payouts_enabled || false)
      return pending
    },
    firstEntry () {
      if (this.userProfile !== undefined) {
        return this.userProfile.firstEntry
      }
      return false
    },
    startedJobs () {
      var jobs = []
      jobs = (this.userJobs || []).filter(item => item.status === 'Hired' || item.status === 'Started' || item.status === 'Scheduled' || item.status === 'Published-Public' || item.status === 'Published-Private')
      return jobs
    },

    invitedJobs () {
      return Object.values((this.userProfile || {}).jobInvites || {}).map(k => {
        return k
      })
    },
    filteredJobs () {
      var filters
      var jobs = this.userJobs.concat(this.invitedJobs)
      filters = (this.userProfile.userType || {}).hefe ? this.hefeFilters : this.obrFilters
      var filterRules = filters.map(k => {
        return item => item.status === k
      })
      return jobs.filter(item => {
        return filterRules.some(f => f(item))
      })
    },
    schedule () {
      var events = []
      if (this.userJobs !== null) {
        this.userJobs.map(k => {
          if (k.schedule) {
            return Object.keys(k.schedule).map(j => {
              if (k.schedule[j] !== 'node_' && k.schedule[j] !== 'ref_') {
                k.schedule[j].start = new Date((k.schedule[j].start))
                k.schedule[j].end = new Date((k.schedule[j].end))
                k.schedule[j].jobData = k
                switch (k.schedule[j].jobData.status) {
                  case 'Started':
                    k.schedule[j].color = 'success'
                    break
                  case 'Hired' :
                    k.schedule[j].color = 'success'
                    break
                  case 'Scheduled' :
                    k.schedule[j].color = 'info'
                    break
                  case 'Completed' || 'Paid':
                    k.schedule[j].color = 'grey'
                    break
                  case 'Pending Payment':
                    k.schedule[j].color = 'amber'
                    break
                  case 'Published-Public':
                    k.schedule[j].color = 'primary'
                    break
                  case 'Published-Private':
                    k.schedule[j].color = 'primary'
                    break
                  case 'Cancelled':
                    k.schedule[j].color = 'grey'
                    break

                  default:
                    break
                }
                events.push(k.schedule[j])
              }
            })
          }
        })
        return events
      }
      return events
    },
    url () {
      if (this.userProfile.balances) {
        return this.userProfile.balances.url
      }
      return null
    },

    mapOptions () {
      if (this.$vuetify.theme.dark) {
        return {
          zoomControl: true,
          mapTypeControl: false,
          // scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: !this.mapDialog,
          disableDefaultUi: false,
          styles: [
            { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
            {
              featureType: 'administrative.locality',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#d59563' }]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#d59563' }]
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [{ color: '#263c3f' }]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{ color: '#38414e' }]
            },
            {
              featureType: 'road',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#212a37' }]
            },
            {
              featureType: 'road',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#9ca5b3' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{ color: '#746855' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#1f2835' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#f3d19c' }]
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [{ color: '#2f3948' }]
            },
            {
              featureType: 'transit.station',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#d59563' }]
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{ color: '#17263c' }]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#515c6d' }]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.stroke',
              stylers: [{ color: '#17263c' }]
            }
          ]
        }
      }
      return {
        zoomControl: true,
        mapTypeControl: false,
        // scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: !this.mapDialog,
        disableDefaultUi: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dde2e3'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'all',
            stylers: [
              {
                color: '#c6e8b3'
              },
              {
                visibility: 'on'
              }
            ]
          },

          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#c6e8b3'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#c1d1d6'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#a9b8bd'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'all',
            stylers: [
              {
                color: '#f8fbfc'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text',
            stylers: [
              {
                color: '#979a9c'
              },
              {
                visibility: 'on'
              },
              {
                weight: 0.5
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on'
              },
              {
                color: '#827e7e'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#3b3c3c'
              },
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#a6cbe3'
              },
              {
                visibility: 'on'
              }
            ]
          }
        ]
      }
    }
    // nextJob() {
    //   var nextJob = (this.userJobs || {}).filter(k => moment(`${k.startDate} ${k.startTime}`) > moment()).sort((a, b) => moment(`${a.startDate} ${a.startTime}`) - moment(`${b.startDate} ${b.startTime}`)).filter(k => k.status !== 'Draft' || k.status !==
    //     'Invited')
    //   return nextJob[0]
    // }
  },

  methods: {
    openInfoWindowTemplate (item) {
      this.infoWindow.job = item
      this.infoWindow.position = this.getCoordinates(item)
      this.infoWindow.open = true
    },
    getCoordinates (job) {
      return {
        lat: parseFloat((job.location || {})[0]),
        lng: parseFloat((job.location || {})[1])
      }
    },

    changeView (val) {
      this.listView = val
    },

    handlePanel () {
      this.filterPanel = this.filterPanel === 0 ? null : 0
    },

    setLoc () {
      var updates = {}

      fb.database.ref('jobs').once('value').then((snapshot) => {
        var data = snapshot.val()
        Object.keys(data).map(k => {
          updates[`user/${this.currentUser.uid}/jobs/${k}/location`] = data[k].public.location
          if (Object.keys(data[k].applicants || {}).length > 0) {
            Object.keys(data[k].applicants).map(l => {
              updates[`user/${l}/jobs/${k}/location`] = data[k].public.location
              updates[`user/${l}/jobs/${k}/category`] = data[k].public.category
            })
          }
        })
        fb.database.ref().update(updates)
      })
    },
    processIcon (job) {
      if (this.google) {
        var icon = {
          url: require(`@/assets/map/${job.category}.svg`),
          /* eslint-disable */
        scaledSize: new google.maps.Size(42, 42)
        /* eslint-enable */
        }
        return icon
      }
    },
    // stripeSignup () {
    //   // dev
    //   window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjx860hxJ1ujCiC0yawQB6oyE0TFaH&stripe_user[first_name]=${this.userProfile.public.firstName}&stripe_user[last_name]=${this.userProfile.public.lastName}&stripe_user[email]=test${this.userProfile.public.email}&stripe_user[phone_number]=0000000000&stripe_user[street_address]=${this.userProfile.address.address1}&stripe_user[city]=${this.userProfile.address.city}&stripe_user[state]=${this.userProfile.address.state}&stripe_user[zip]=${this.userProfile.address.zip}&stripe_user[country]=US&scope=read_write`
    //   // prod
    //   // window.location.href = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_CNBjvPagvg5ImtTPpEpbScvmuWig3SMS&stripe_user[email]=${this.userProfile.public.email}&stripe_user[phone_number]=${this.userProfile.public.mobilePhone}&scope=read_write`
    // },
    createLink () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/balances/getNewURL`] = new Date()
      updates[`user/${this.currentUser.uid}/profile/balances/waitingForUrl`] = true
      fb.database.ref().update(updates)
    },
    isFilterSelected (option) {
      // This could have been done with an object with text and value, filter by the value but show the text. I wanted to try doing it this way.
      let original = ((this.userProfile || {}).userType || {}).obr ? ['No filter', 'Hired', 'Applied', 'Invites', 'Completed'] : ['No filter', 'Draft', 'Active', 'Hiring', 'Scheduled', 'Pending Payment', 'Completed']
      return original.indexOf(option) === (((this.userProfile || {}).userType || {}).obr ? this.$language.dashboard['obreroFilters'] : this.$language.dashboard['hefeFilters']).indexOf(this.filter)
    },

    processInvites (invites) {
      return Object.keys(invites).map(k => k)
        .filter(item => item !== 'alive')
        .filter(key => {
          let job = this.userJobs.find(job => {
            return job._key === key
          })
          // If it doesn't find a job with a key that matches an invitation it means the user has not taken any action with that invite (i.e applied)
          // If it finds a matching job, return the key only if the job status is different from cancelled. Probably have to add completed here too
          if (!job || (job && job.status !== 'Cancelled')) {
            return key
          }
        })
    },

    handleClose (event) {
      this.snackbar.show = event.show
      this.snackbar.message = event.message
      if (event.job) {
        this.defaultTab = 'Applicants'
        this.thisJob = {
          _key: event.job
        }
        this.dialogs['job-details'] = true
      } else {
        this.defaultTab = 'Summary'
        this.thisJob = this.defaultJob
      }

      this.dialogs[event.window] = false
    },
    handleCloseJob () {
      this.thisJob = this.defaultJob
      this.defaultTab = 'Summary'
      if (this.backToTransactions) {
        this.$router.push('/hefe/payments')
      }
      this.backToTransactions = false

      this.dialogs['job-details'] = false
    },
    handleCloseFav () {
      this.dialogs['favorites-invite'] = false
      this.dialogs['add-job'] = false
    },
    editJob (job) {
      this.jobToEdit = null
      this.jobToEdit = job
      this.dialogs['job-details'] = false
      this.dialogs['job-edit'] = true
    },

    openDialog (data, tab) {
      this.thisJob = data
      this.defaultTab = tab
      // this.dialogs['job-details'] = true
    },
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format('dddd, MMMM Do YYYY') : ''
    },
    dayOfWeek (val) {
      if (!val) {
        return '-'
      }
      switch (moment(val).day()) {
        case 1:
          return this.$language.addJob['Monday']
        case 2:
          return this.$language.addJob['Tuesday']
        case 3:
          return this.$language.addJob['Wednesday']
        case 4:
          return this.$language.addJob['Thursday']
        case 5:
          return this.$language.addJob['Friday']
        case 6:
          return this.$language.addJob['Saturday']
        case 0:
          return this.$language.addJob['Sunday']
        default:
          break
      }
      return moment(val).day()
    },
    nth (val) {
      if (!val) {
        return '-'
      }
      switch (Math.ceil(moment(val).date() / 7)) {
        case 1:
          return this.$language.addJob['1st']
        case 2:
          return this.$language.addJob['2nd']
        case 3:
          return this.$language.addJob['3rd']
        case 4:
          return this.$language.addJob['4th']
        case 5:
          return this.$language.addJob['5th']
        default:
          break
      }
      return moment(val).day()
    },

    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    updateRange ({ start, end }) {
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay
        })
      }
      // this.events = events
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    }
  },
  watch: {

    addDialog () {
      this.jobToEdit = null
      this.dialogs['job-edit'] = true
    },
    openJob () {
      this.openJob.job._key = this.openJob.job.jobId
      this.thisJob = this.openJob.job
      this.defaultTab = this.openJob.tab
      this.backToTransactions = true
      this.dialogs['job-details'] = true
    },
    url () {
      if (this.userProfile.balances.waitingForUrl === false) {
        window.location.href = this.url
      }
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/balances/waitingForUrl`] = null
      updates[`user/${this.currentUser.uid}/profile/balances/url`] = null
      fb.database.ref().update(updates)
    }
  },
  filters: {
    svgURL (val) {
      return `@assets/${val}`
    },
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    }
  }
}
</script>
// <style lang="scss">
// .route {
//   text-decoration: none;
// }
//
</style>
